/**
 * 共建店导入 2020-02-20
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool,utils_tool } from '@/tool'
let { WizTypography, WizSpin } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
import { ExportExcel } from '@/components/index'
import { modelUtils } from '@/utils'
let { Session } = utils_tool

class ClassResultFileImport extends WizContainer {

  componentName = 'classResultFileImport';

  constructor(props) {
    super(props);
    let classInfoId = "";
    const { history } = props
    if (history.location && history.location.pathname === '/face/classList/classResult/classResultFileImport') {
      if (history.location && history.location.record) {
        classInfoId = history.location.record.classInfoId
        Session.set('classInfoId', classInfoId)
      } else {
        classInfoId = Session.get('classInfoId') || {}
      }
    }
    this.classInfoId = classInfoId
    this.state = {
    }
  }

  _handldImport(nextProps, nextState) {
    let o = nextProps['classResultImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  propsAndStateOnChange = {
    classResultImport: this._handldImport.bind(this),
  }


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '成绩导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_classResultTemp,
      }

    }
    let submit = (file, fileData) => {
      let apiPath = 'classResult/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
            "classInfoId":this.classInfoId
          }
        }
      });
    }
    let { classResultLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={classResultLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { classResult } = state;
  const classResultImport = modelUtils.getModelEntity(classResult, 'import');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'classResult')
  return {
    classResultImport: classResultImport,
    ...load
  }
};

export default connect(mapStateToProps)(ClassResultFileImport);
